import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/pages/alert-detail-page/alert-detail-page.js';
      import {AlertDetailPageType} from '@oicl/openbridge-webcomponents/dist/pages/alert-detail-page/alert-detail-page.js';
import {Alert, TimeSinceFn} from '@oicl/openbridge-webcomponents/dist/types.js';

      export interface Props {
     type?: AlertDetailPageType;
     alert?: Alert;
     hasNote?: boolean;
     hasActions?: boolean;
     hasTagId?: boolean;
     hasCategory?: boolean;
     hasActivated?: boolean;
     hasTimer?: boolean;
     hasAcknowledged?: boolean;
     hasAcknowledgedBy?: boolean;
     hasRectified?: boolean;
     hasShelvingTimer?: boolean;
     hasShelvedBy?: boolean;
     hasReadoutGraph?: boolean;
     timeFormatter?: (time: Date) => string;
     timeSinceFormatter?: TimeSinceFn
   }

      
  
      export type {AlertDetailPageType} from '@oicl/openbridge-webcomponents/dist/pages/alert-detail-page/alert-detail-page.js';
export type {Alert, TimeSinceFn} from '@oicl/openbridge-webcomponents/dist/types.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcAlertDetailPage',
  props: {
    type: {},
    alert: {},
    hasNote: { type: Boolean },
    hasActions: { type: Boolean },
    hasTagId: { type: Boolean },
    hasCategory: { type: Boolean },
    hasActivated: { type: Boolean },
    hasTimer: { type: Boolean },
    hasAcknowledged: { type: Boolean },
    hasAcknowledgedBy: { type: Boolean },
    hasRectified: { type: Boolean },
    hasShelvingTimer: { type: Boolean },
    hasShelvedBy: { type: Boolean },
    hasReadoutGraph: { type: Boolean },
    timeFormatter: { type: Function },
    timeSinceFormatter: { type: Function }
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-alert-detail-page',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})